<template>
  <base-button class="dropdown-toggle" data-coreui-toggle="dropdown" aria-expanded="false" :text="text" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'DropdownButton',
  components: {
    BaseButton,
  },
  props: {
    text: {
      type: String,
      required: true
    },
  }
}
</script>
